import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation('common');

  const services = [
    {
      icon: 'ri-store-2-line',
      title: t('services.wholesale'),
      description: t('services.wholesaleDesc'),
    },
    {
      icon: 'ri-truck-line',
      title: t('services.delivery'),
      description: t('services.deliveryDesc'),
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('services.support'),
      description: t('services.supportDesc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('services.warranty'),
      description: t('services.warrantyDesc'),
    },
  ];

  return (
    <section className="py-10 md:py-20 bg-gray-50">
      <div className="container mx-auto px-3 md:px-6">
        <div className="text-center mb-6 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-2 md:mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xs md:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-4 md:p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="w-10 h-10 md:w-16 md:h-16 bg-teal-100 rounded-lg flex items-center justify-center mb-3 md:mb-6">
                <i className={`${service.icon} text-xl md:text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-sm md:text-xl font-bold text-gray-900 mb-1.5 md:mb-3">
                {service.title}
              </h3>
              <p className="text-[9px] md:text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}